import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import { hiddenHandler } from '../../../FixedColumn/helpers'

import { getNumberMagnitude, formatValueByMagnitude } from '../../helpers'

import './style.scss'

export default class ColumnBody extends Component {
    static propTypes = {
        activeRowIndex: PropTypes.string,
        column: PropTypes.object.isRequired,
        decimalPlaces: PropTypes.number,
        handleMouseLeaveRow: PropTypes.func.isRequired,
        handleRowHover: PropTypes.func.isRequired,
        isAdvanced: PropTypes.bool,
        numberMagnitude: PropTypes.number,
        openRows: PropTypes.array,
        sectionsDefinition: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                rows: PropTypes.arrayOf(
                    PropTypes.shape({
                        prefix: PropTypes.string,
                        highlight: PropTypes.bool,
                        text: PropTypes.string.isRequired,
                        columnCode: PropTypes.string.isRequired,
                        indentationLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        configuration: PropTypes.shape({
                            unit: PropTypes.string,
                            higherIsBetter: PropTypes.string,
                        }),
                    })
                ).isRequired,
            })
        ),
    }

    static defaultProps = {
        isAdvanced: false,
    }

    render() {
        const {
            column,
            sectionsDefinition,
            activeRowIndex,
            handleMouseLeaveRow,
            handleRowHover,
            openRows,
            isAdvanced,
            decimalPlaces,
            numberMagnitude,
        } = this.props

        const magnitude = getNumberMagnitude(numberMagnitude)

        return (
            <div className={'dc-column-body'}>
                {_.map(sectionsDefinition, (section, sectionIndex) => (
                    <div key={`${section.typeCode}-section`} className={'dc-section'}>
                        <div className={'ft-row dc-row section-title'} />
                        {_.map(
                            _.get(section, 'rows', []),
                            (row, index) =>
                                (!isAdvanced || (isAdvanced && !hiddenHandler(row, openRows))) && (
                                    <div
                                        onMouseOver={() => handleRowHover(`${sectionIndex}-${index}`)}
                                        onMouseLeave={() => handleMouseLeaveRow()}
                                        onFocus={() => handleRowHover(`${sectionIndex}-${index}`)}
                                        key={`dc-${row.columnCode}-row`}
                                        className={classnames(
                                            'ft-row',
                                            'dc-row',
                                            row.highlight && 'sum-row',
                                            activeRowIndex === `${sectionIndex}-${index}` && 'active'
                                        )}
                                    >
                                        <span
                                            className={classnames(
                                                'dc-row-value',
                                                _.get(column, `values.${row.columnCode}`) < 0 && 'negative'
                                            )}
                                        >
                                            {formatValueByMagnitude(
                                                _.get(column, `values.${row.columnCode}`, null),
                                                magnitude,
                                                decimalPlaces
                                            )}
                                        </span>
                                    </div>
                                )
                        )}
                    </div>
                ))}
            </div>
        )
    }
}
